import React from "react";
import { motion, useReducedMotion, type Variants } from "motion/react";
import { EASE_OUT } from "../../lib/motion";

function itemVariants(reduced: boolean | null, delay = 0): Variants {
  return {
    hidden: reduced ? { opacity: 0 } : { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: reduced ? 0.12 : 0.48, delay: reduced ? 0 : delay, ease: EASE_OUT } },
  };
}

export function Reveal({ children, className = "", delay = 0 }: { children: React.ReactNode; className?: string; delay?: number }) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "0px 0px -32px 0px" }}
      variants={itemVariants(reduced, delay)}
    >
      {children}
    </motion.div>
  );
}

export function RevealGroup({ children, className = "", stagger = 0.08 }: { children: React.ReactNode; className?: string; stagger?: number }) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "0px 0px -32px 0px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: reduced ? 0 : stagger } } }}
    >
      {children}
    </motion.div>
  );
}

export function RevealSection({ children, className }: { children: React.ReactNode; className?: string }) {
  const reduced = useReducedMotion();
  return (
    <motion.section
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "0px 0px -32px 0px" }}
      variants={itemVariants(reduced)}
    >
      {children}
    </motion.section>
  );
}

export function RevealItem({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  const reduced = useReducedMotion();
  return (
    <motion.div className={className} variants={itemVariants(reduced)}>
      {children}
    </motion.div>
  );
}
